import { __ } from "@libs/utilities"
import { IState, NOTIFICATION_ADMIN_MODE, useMainStore } from "@/settings/zustand"
import { isRole } from "@/settings/zustand/user"
import { Button, ButtonGroup } from "@blueprintjs/core"

/* Protopia Ecosystem component */
export interface INotificationLayoutProps {
   children: JSX.Element
   containerClassName?:string
}
const NotificationLayout = (props: INotificationLayoutProps): JSX.Element => { 
    const notificationAdminMode = useMainStore((state: IState) => state.notificationAdminMode)

    const onMode = (notificationAdminMode:NOTIFICATION_ADMIN_MODE) => {
        useMainStore.setState({notificationAdminMode})
    }
    return <div className={ ` ${props.containerClassName} py-3 px-0` }>
        {
            isRole(["SuperAdmin", "admin"]) && 
            <div className="row w-100 pl-1 pl-md-0 pr-0 pr-md-0">
                <div>
                    <ButtonGroup >
                        <Button variant={notificationAdminMode !== NOTIFICATION_ADMIN_MODE.ALL ? "minimal": "solid"} onClick={() => onMode(NOTIFICATION_ADMIN_MODE.ALL)}>
                            <span className="descr text-force-contrast hover">
                                {__("All")}
                            </span>
                        </Button>
                        <Button variant={notificationAdminMode !== NOTIFICATION_ADMIN_MODE.ONLY_MINE ? "minimal": "solid"} onClick={() => onMode(NOTIFICATION_ADMIN_MODE.ONLY_MINE)}>
                            <span className="descr text-force-contrast hover">
                                {__("Only mine")}
                            </span>
                        </Button>
                    </ButtonGroup>
                </div>
            </div>
        } 
        <div className="row w-100 pl-1 pl-md-0 pr-0 pr-md-0 mb-5">
            { props.children }
        </div> 
    </div>
}
export default NotificationLayout